export default __webpack_public_path__ + "static/media/18.3dee161f.png";